var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              width: "200",
              prop: "fileName",
              label: _vm.$t("billingPage.FileName"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "64",
              prop: "carrier",
              label: _vm.$t("billingPage.Carrie"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "150",
              prop: "operatedDate",
              label: _vm.$t("billingPage.OperatedDate"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "80",
              prop: "createdBy",
              label: _vm.$t("billingPage.Operator"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "94",
              prop: "weekyear",
              label: _vm.$t("billingPage.YearWeek"),
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (props) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(props.row.year) + " / " + _vm._s(props.row.week)
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              width: "155",
              prop: "surchargedItems",
              label: _vm.$t("billingPage.SurchargedItems"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              width: "150",
              prop: "surchargedAmount",
              label: _vm.$t("billingPage.SurchargedAmount"),
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "detail",
              label: _vm.$t("detailsText"),
              align: "center",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }